import "./review.css"
import review_logo from "../../../assets/logo.svg";
import review from "../../../assets/review.png";
import React from "react";
import {Link} from "react-router-dom";
import {connect} from "react-redux";
import {useTranslation} from "react-i18next";
import Logout from "../../logout/Logout";

function Review({appData, personalData, financialInfo, expInfoData, account, selectedLabel, selectedOption}) {

    const print = () => window.print();

    const {t} = useTranslation()
    const shouldDisplaySelectedLabel = selectedOption !== "level0";

    function getCitizenshipStatus(status) {
        if (status === 'UsCitizen') {
            return 'U.S. Citizen';
        } else if (status === 'ResidentAlien') {
            return 'Resident Alien';
        } else if (status === 'non_resident') {
            return 'Non Resident';
        } else {
            return 'Unknown Citizenship Status';
        }
    }

    return (
        <div className="review">
            <div className="review_left_side">
                <img src={review_logo} alt=""/>
                <img style={{paddingTop: "12%"}} src={review} alt=""/>
            </div>
            <div className="review_right_side">
                <Logout/>
                <div className="review_app">
                    <p className="review_heading">{t('review.next')} {personalData.firstName} {personalData.lastName} {t('review.review_info')}
                        <button onClick={print} className="print_btn">{t('review.click_here')}</button>
                        {t('review.print_page')}</p>
                    <p className="review_app_heading">{t('review.review_app')}</p>
                    <div>
                        <div className="app_editing_part">
                            <div className="app_editing_left_part">
                                <div>
                                    <div>
                                        <span className="app_edit_heading">{t('review.registration')}</span>
                                        <Link to="/">
                                            <button className="edit_btn">{t('review.edit')}</button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists">
                                        <li>{t('review.citizen_status')} {getCitizenshipStatus(appData.citizenship_status)}</li>
                                        <li>{t('review.account_type')} {appData.account_type}</li>
                                    </ul>
                                </div>

                                <div>
                                    <div>
                                        <span className="app_edit_heading">{t('review.personal_info')}</span>
                                        <Link to="/personal">
                                            <button className="edit_btn">{t('review.edit')}</button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists">
                                        <li>{t('review.title')} {personalData.title}</li>
                                        <li>{t('review.first_name')} {personalData.firstName}</li>
                                        <li>{t('review.last_name')} {personalData.lastName}</li>
                                        <li>{t('review.ssn')} {personalData.ssn}</li>
                                        <li>{t('review.date_of_birth')} {personalData.birth}</li>
                                        <li>{t('review.marital_status')} {personalData.maritalStatus}</li>
                                    </ul>
                                </div>

                                <div>
                                    <div>
                                        <span className="app_edit_heading">{t('review.permanent_address')}</span>
                                        <Link to="/personal">
                                            <button className="edit_btn">{t('review.edit')}</button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists">
                                        <li>{t('review.permanent_address')} {personalData.permAddress}</li>
                                        <li>{t('review.address2')} {personalData.address2}</li>
                                        <li>{t('review.city')} {personalData.city}</li>
                                        <li>{t('review.zip_code')} {personalData.zipCode}</li>
                                        <li>{t('review.country')} {personalData.country}</li>
                                    </ul>
                                </div>
                                <div>
                                    <div>
                                        <span className="app_edit_heading">{t('review.employment')}</span>
                                        <Link to="/personal">
                                            <button className="edit_btn">{t('review.edit')}</button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists">
                                        <li>{t('review.employment_status')} {financialInfo.emplStatus}</li>
                                    </ul>
                                </div>
                            </div>

                            <div className="app_editing_right_part">
                                <div>
                                    <div>
                                        <span className="app_edit_heading">{t('review.contact_info')}</span>
                                        <Link to="/personal">
                                            <button className="edit_btn">{t('review.edit')}</button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists">
                                        <li>{t('review.phone')} {personalData.phone}</li>
                                        <li>{t('review.email')} {appData.email}</li>
                                    </ul>
                                </div>

                                <div>
                                    <div>
                                        <span className="app_edit_heading">{t('review.financial_info')}</span>
                                        <Link to="/financial">
                                            <button className="edit_btn">{t('review.edit')}</button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists">
                                        <li>{t('review.source_of_income')} {financialInfo.sourceOfIncome}</li>
                                        <li>{t('review.annual_income')} {financialInfo.annualIncome}</li>
                                        <li>{t('review.liquid_assets')} {financialInfo.assets}</li>
                                        <li>{t('review.net_worth')} {financialInfo.netWorth}</li>
                                    </ul>
                                </div>

                                <div>
                                    <div>
                                        <span className="app_edit_heading">{t('review.account_privileges')}</span>
                                        <Link to="/account">
                                            <button className="edit_btn">{t('review.edit')}</button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists">
                                        <li>{t('review.investment_account_type')} {account.accountType}</li>
                                        {shouldDisplaySelectedLabel && <li>{t('review.investment')} Options</li>}
                                    </ul>
                                </div>

                                <div>
                                    <div>
                                        <span className="app_edit_heading">{t('review.mailing_address')}</span>
                                        <Link to="/personal">
                                            <button className="edit_btn">{t('review.edit')}</button>
                                        </Link>
                                    </div>
                                    <ul className="app_edit_lists">
                                        <li>{t('review.perm_address')} {personalData.permAddress}</li>
                                        <li>{t('review.mailing_address')} {personalData.mailingAddress}</li>
                                        <li>{t('review.mailing_address2')} {personalData.mailingAddress2}</li>
                                        <li>{t('review.mailing_city')} {personalData.mailingCity}</li>
                                        <li>{t('review.mailing_state')} {personalData.state}</li>
                                        <li>{t('review.mailing_zip_code')} {personalData.mailingZipCode}</li>
                                        <li>{t('review.mailing_country')} {personalData.mailingCountry}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="review_investment">
                                <span className="app_edit_heading">{t('review.previous_investment')}</span>
                                <Link to="/experience">
                                    <button className="edit_btn">{t('review.edit')}</button>
                                </Link>
                            </div>
                            <div className="stock_option">
                                <div>
                                    <span className="invest_exp_types">{t('review.stocks')}</span>
                                    <ul className="app_edit_lists">
                                        <li>{t('review.year')} {expInfoData.stockYear}</li>
                                        <li>{t('review.average_size')} {expInfoData.stockAverageSize}</li>
                                        <li>{t('review.average_number')} {expInfoData.stockAverageNumber}</li>
                                    </ul>
                                </div>
                                <div className="options_end_list">
                                    <span className="invest_exp_types">{t('review.options')}</span>
                                    <ul className="app_edit_lists end_list">
                                        <li>{t('review.year')} {expInfoData.optionYear}</li>
                                        <li>{t('review.average_size')} {expInfoData.optionAverageSize}</li>
                                        <li>{t('review.average_number')} {expInfoData.optionAverageNumber}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="review_investment_objective">
                                <span className="app_edit_heading">{t('review.investment_objective')}</span>
                                <Link to="/experience">
                                    <button className="edit_btn">{t('review.edit')}</button>
                                </Link>
                            </div>
                            <p className="objectives_text">{t('review.investment_experience_text')}</p>
                        </div>

                        {shouldDisplaySelectedLabel && <div>
                            <div className="review_specific_option">
                                <span className="app_edit_heading">{t('review.specific_option_level')}</span>
                                <Link to="/account">
                                    <button className="edit_btn">{t('review.edit')}</button>
                                </Link>
                            </div>
                            <p className="objectives_text">{t('account.' + selectedLabel)}</p>
                        </div>}
                    </div>
                </div>
                <div className="review_btn">
                    <Link style={{textDecoration: "none"}} to="/conditions">
                        <button className="review_back_btn">{t('back_btn')}</button>
                    </Link>
                    <Link to="/signature" style={{textDecoration: "none"}}>
                        <button className="review_continue_btn" type="submit">{t('next_btn')}</button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        appData: state.appData,
        personalData: state.personalData,
        financialInfo: state.financialInfo,
        expInfoData: state.expInfoData,
        account: state.account,
        selectedLabel: state.account.selectedLabel,
        selectedOption: state.account.selectedOption,
    };
};

export default connect(mapStateToProps)(Review);